export default __webpack_public_path__ + "static/media/Tread-Orange.71372865.svg";